import React from "react";
import { Container } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner web">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">JAVA <span>&</span> J2EE <br /> DEVELOPMENT</h2>
						<div className="red-border"> </div>
						<p>digiPanda is an offshore Java development company in India with an enviable track record of excellence that innovates ideas into real world software applications using cutting-edge Java technologies.</p>
						<Link to="/contact-us" className="red-btn"> GET FREE ESTIMATION </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
